export const VIEWS = {
  ENTER_AMOUNT: 'enterAmount',
  ENTER_RECEIVER: 'enterReceiver',
  REVIEW: 'review',
  SUCCESS: 'success'
};

export const VIEWS_STORAGE = {
  ENTER_AMOUNT: 'enterAmount',
  CONFIRM: 'confirm',
  SUCCESS: 'success'
};

export const VIEWS_STORAGE_WITHDRAW = {
  ENTER_AMOUNT: 'enterAmount',
  SUCCESS: 'success'
};

export const STEPS = {
  CHOOSE_PROJECTS: 'chooseProjects',
  ENTER_AMOUNT: 'enterAmount',
  ENTER_RECIPIENT: 'enterRecipient'
};

export const typeOptions = [
  {
    value: '',
    label: 'All'
  },
  {
    value: 'opn_send',
    label: 'Sent OPN'
  },
  {
    value: 'occ_send',
    label: 'Sent OCC'
  },
  {
    value: 'opn_received',
    label: 'Received OPN'
  },
  {
    value: 'occ_received',
    label: 'Received OCC'
  },
  {
    value: 'plant',
    label: 'Planted OPN'
  },
  {
    value: 'opn_withdraw',
    label: 'Withdrawn OPN'
  },
  {
    value: 'occ_withdraw',
    label: 'Withdrawn OCC'
  },
  {
    value: 'offset',
    label: 'Retired OCC'
  },
];

export const tokenOptions = [
  {
    value: 'OPN',
    label: 'OPN'
  },
  {
    value: 'OCC',
    label: 'OCC'
  },
  {
    value: 'USDC',
    label: 'USDC'
  },
  {
    value: 'NEAR',
    label: 'Near'
  }

];

export const tabsOptions = [
  {
    label: 'Send',
    value: 'send'
  },
  {
    label: 'Receive',
    value: 'receive'
  }
];

export const storageTabsOptions =
[
  {
    label: 'My Storage Balance',
    value: 'myStorageBalance'
  },
  {
    label: 'Send By ID',
    value: 'sendById'
  }
];
